import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {smssigns, smssignOne} = api



/**
 * 查找短信签名
 */
export async function findSmssigns(params) {
    return request({url: smssigns, method: 'get', data: params})
}

/**
 * 删除短信签名
 */
export async function addSmssigns(params) {
    return request({url: smssigns, method: 'post', data: params})
}

/**
 * 删除短信签名
 */
export async function delSmssigns(params) {
    return request({url: smssignOne, method: 'delete', data: params})
}






// WEBPACK FOOTER //
// ./src/services/smssigns.js